import React, { Component } from 'react';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import saveAs from 'file-saver';

const propTypes = {
  table: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  sheet: PropTypes.string.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  buttonText: PropTypes.string,
};

const defaultProps = {
  id: 'button-download-as-xls',
  className: 'button-download',
  buttonText: 'Download',
};

class ExcelExport extends Component {
  constructor(props) {
    super(props);
    this.handleDownload = this.handleDownload.bind(this);
  }

  static base64(s) {
    return window.btoa(unescape(encodeURIComponent(s)));
  }

  static format(s, c) {
    return s.replace(/{(\w+)}/g, (m, p) => c[p]);
  }
  
  static s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  handleDownload() {
    if (!document) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Failed to access document object');
      }

      return null;
    }

    if (document.getElementById(this.props.table).nodeType !== 1 || document.getElementById(this.props.table).nodeName !== 'TABLE') {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Provided table property is not html table element');
      }

      return null;
    }

    //Get the currently active MRSAM
    var mrsam;
    var mrsamType = document.getElementsByClassName('Report')[0].id;
    switch (mrsamType) {
      case "Species":
          mrsam = Window.vms;
          break;
      case "Gear":
        mrsam = Window.vmg;
          break;
      case "Charter":
          mrsam = Window.vmc;
          break;
          
  }


    var wb = XLSX.utils.book_new();
    var ws_inputs = XLSX.utils.aoa_to_sheet([[mrsamType]]);
    XLSX.utils.sheet_add_aoa(ws_inputs, [['Inputs']], {origin: "A3"});
    //Start with the Deflator
    var year = document.getElementsByClassName('ImpactYear')[0].getElementsByClassName('OptionSelected')[0].innerText;
    XLSX.utils.sheet_add_aoa(ws_inputs, [['GDP Deflator:']], {origin: "A5"});
    XLSX.utils.sheet_add_aoa(ws_inputs, [['Year', 'GDP Deflator'],[year, mrsam.finalDeflator()]], {origin: "B5"});

    //Now the input vector. Can include all or only nonzero.
    var sv_names = [];
    var sv_vals = [];
    mrsam.iv_disp().forEach(element => {
      if (mrsam.mrsam_shock_vec[element.region][element.sector]() !== 0) {
        sv_names.push(element.region + ' ' + element.sector);
        sv_vals.push(mrsam.mrsam_shock_vec[element.region][element.sector]());
      }
    })

    XLSX.utils.sheet_add_aoa(ws_inputs, [['Shock Vector:']], {origin: "A8"});
    XLSX.utils.sheet_add_aoa(ws_inputs, [sv_names, sv_vals], {origin: "B8"});
    XLSX.utils.book_append_sheet(wb, ws_inputs, "Inputs");

    //Add report sheets
    var reports = document.getElementsByClassName('Report')[0].getElementsByClassName("table-content-export")
    Array.from(reports).forEach(element => {
        var reptName = element.getElementsByClassName('table-title')[0].innerText;
        wb.SheetNames.push(reptName.substring(0,31));
        var ws2 = XLSX.utils.table_to_sheet(element);
        XLSX.utils.sheet_add_aoa(ws2, [[reptName]], {origin: 'A1'});
        wb.Sheets[reptName.substring(0,31)] = ws2;
    });

    var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});

    saveAs(new Blob([ExcelExport.s2ab(wbout)],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}), "MRSAM " + mrsamType + " Model Output.xlsx");

    return true;
  }

  render() {
    return (
      <div
        id={this.props.id}
        className={this.props.className}
        onClick={this.handleDownload}>{this.props.buttonText}
    </div>
    );
  }
}

ExcelExport.propTypes = propTypes;
ExcelExport.defaultProps = defaultProps;

export default ExcelExport;